import { BrowserContext } from '@playwright/test';

import {
  archivedKycMocks,
  checkErrorMock,
  defaultCountryItMocks,
  emailEscalationMocks,
  errorGetIterationMocks,
  errorsMocks,
  escalationDeclinedMock,
  escalationErrorMock,
  esgApprovedMocks,
  esgRejectedMocks,
  freshCveMocks,
  gerlAdditionalCheckedMocks,
  gerlCommentMocks,
  gerlNotFoundMocks,
  gerlWithUpMocks,
  gradeExpiredMocks,
  gradeMissingMocks,
  missingRightsMock,
  multipleDocumentsMock,
  nordicUserMocks,
  pecMocks,
  quizAnswersMocks,
  repRiskInReviewMocks,
  repRiskSavedMocks,
  sensitiveBusinessInReviewMocks,
  sessionExpiredMocks,
  supportRequestOpenMocks,
  tradeSectorMocks,
  userUnavailableMocks,
  validatedKycMocks,
  validateKycMocks,
} from '#scenarios/index';

export interface HttpMock {
  request: {
    method: 'GET' | 'POST';
    urlPathPattern: string;
  };
  response: {
    status: number;
    body: unknown;
    headers?: Record<string, string>;
  };
}

export function getMocksByScenarios(scenariosNames: string[]): HttpMock[] {
  return scenariosNames.map((name) => getMocksByScenario(name)).flat();
}

function getMocksByScenario(scenarioName: string): HttpMock[] {
  switch (scenarioName) {
    case 'grade-expired':
      return gradeExpiredMocks;
    case 'errors':
      return errorsMocks;
    case 'user-unavailable':
      return userUnavailableMocks;
    case 'session-expired':
      return sessionExpiredMocks;
    case 'default-country-it':
      return defaultCountryItMocks;
    case 'email-escalation':
      return emailEscalationMocks;
    case 'quiz-answers':
      return quizAnswersMocks;
    case 'esg-approved':
      return esgApprovedMocks;
    case 'esg-rejected':
      return esgRejectedMocks;
    case 'archived-kyc':
      return archivedKycMocks;
    case 'pec':
      return pecMocks;
    case 'trade-sector':
      return tradeSectorMocks;
    case 'escalation-declined':
      return escalationDeclinedMock;
    case 'escalation-error':
      return escalationErrorMock;
    case 'check-error':
      return checkErrorMock;
    case 'gerl-not-found':
      return gerlNotFoundMocks;
    case 'gerl-comment':
      return gerlCommentMocks;
    case 'multiple-documents':
      return multipleDocumentsMock;
    case 'missing-rights':
      return missingRightsMock;
    case 'fresh-cve':
      return freshCveMocks;
    case 'grade-missing':
      return gradeMissingMocks;
    case 'error-get-iteration':
      return errorGetIterationMocks;
    case 'validate-kyc':
      return validateKycMocks;
    case 'validated-kyc':
      return validatedKycMocks;
    case 'support-request-open':
      return supportRequestOpenMocks;
    case 'nordic-user':
      return nordicUserMocks;
    case 'gerl-with-up':
      return gerlWithUpMocks;
    case 'gerl-additional-checked':
      return gerlAdditionalCheckedMocks;
    case 'rep-risk-saved':
      return repRiskSavedMocks;
    case 'sensitive-business-in-review':
      return sensitiveBusinessInReviewMocks;
    case 'rep-risk-in-review':
      return repRiskInReviewMocks;
    default:
      console.error(`Mock scenario "${scenarioName}" does not exist`);
      throw new Error(`Mock scenario "${scenarioName}" does not exist`);
  }
}

export async function setMockScenarios(context: BrowserContext, ...scenariosNames: string[]) {
  await context.addCookies([{ name: 'mockScenarios', value: scenariosNames.join(','), url: 'http://localhost:4200' }]);
}
